import { getFeatures } from '../features';

const get = require('lodash/get');
const isEqual = require('lodash/isEqual');
const pick = require('lodash/pick');
const log = require('./log');


const attributesToSync = [
  'prices_metafield_key', // DEPRECATED: prices metafield namespace for localized pricing
  'geo_currency',         // geolocated currency from flow session api
  'geo_country',          // geolocated country from flow session api
  'flow_metafield_key',   // generic flow metafield namespace
  'shipping_configuration_key', // Allows order to show item availability for all countries
  'shopify_localization_method', // Manual override for using Server Side Rendering. Possible values: ssr, api
  'features', // escaped & delimited features key-value string
];

function serialiseFeatures({ values }) {
  return values.map(f => `${f.feature.key}\\:${f.value}`).join('\\|');
}

function getAttributesToSync(sessionOrCart) {
  return pick(get(sessionOrCart, 'attributes'), attributesToSync);
}

function syncCartAttributes(session, cart) {
  return new Promise((resolve) => {
    const sessionAttributesToSync = getAttributesToSync(session);

    cart.getCart({
      onSuccess: ({ shopifyCart }) => {
        const shopifyCartAttributes = getAttributesToSync(shopifyCart);

        // Sync features on the cart attributes
        getFeatures().then((features) => {
          sessionAttributesToSync.features = serialiseFeatures(features);
        }).finally(() => {
          // Shopify expects a null value to remove attributes from the cart
          if (!get(session, 'experience')) {
            sessionAttributesToSync.prices_metafield_key = null;
            sessionAttributesToSync.geo_currency = null;
            sessionAttributesToSync.geo_country = null;
            sessionAttributesToSync.flow_metafield_key = null;
            sessionAttributesToSync.shipping_configuration_key = null;
            sessionAttributesToSync.features = null;
          }

          if (!isEqual(sessionAttributesToSync, shopifyCartAttributes)) {
            const formAttributes = {
              ...shopifyCart.attributes,
              ...sessionAttributesToSync,
            };

            cart.setAttributes({
              replace: true,
              attributes: formAttributes,
              onSuccess: () => resolve(),
              onError: (error) => {
                log('[flow.js] failed to sync attributes to the cart', error);
                resolve();
              },
            });
          } else {
            resolve();
          }
        });
      },
      onError: (error) => {
        log('[flow.js] failed to get cart', error);
        resolve();
      },
    });
  });
}

module.exports = syncCartAttributes;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/sync-cart-attributes.js